/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Reference Table
 */
export enum logRefTable {
    ADDRESS = 'address',
    CANCER_SPECIALIZATIONS = 'cancer_specializations',
    CUSTOMER = 'customer',
    DIAGNOSIS_DOMAIN = 'diagnosis_domain',
    GRANT_PROGRAM = 'grant_program',
    GRANT_PROGRAM_DIAG_DOMAINS = 'grant_program_diag_domains',
    GRANT_PROGRAM_DIAGNOSIS = 'grant_program_diagnosis',
    GRANT_PROGRAM_POOLS = 'grant_program_pools',
    MASTER_CANCER_GROUP = 'master_cancer_group',
    MASTER_CANCER_TYPE = 'master_cancer_type',
    MEMBERSHIP_CENSUS = 'membership_census',
    MEMBERSHIP_PLAN = 'membership_plan',
    MEMBERSHIP_PLAN_LINKS = 'membership_plan_links',
    MEMBERSHIP_PLAN_SURGE = 'membership_plan_surge',
    MEMBERSHIP_PLAN_FILES = 'membership_plan_files',
    NOTIFICATION_PREFERENCE = 'notification_preference',
    PHONE = 'phone',
    PLAN_GRANT_HASH = 'plan_grant_hash',
    POOLS = 'pools',
    POOLS_DIAGNOSIS_HASH = 'pools_diagnosis_hash',
    POOLS_EXPERTS_HASH = 'pools_experts_hash',
    POOLS_PLANS_HASH = 'pools_plans_hash',
    QUERY_HEADER = 'query_header',
    QUERY_HEADER_INPUT = 'query_header_input',
    TENANT = 'tenant',
    UNKNOWN = 'unknown',
    USER = 'user',
    USER_AWAY = 'user_away',
    USER_BIO = 'user_bio',
    USER_INVITE = 'user_invite',
    USER_MFA = 'user_mfa',
    USER_TAX_INFORMATION = 'user_tax_information',
}